export default __webpack_public_path__ + "static/media/3.5a41ccc5.png";